import { Injectable } from '@angular/core';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataListModel} from '../../models/data-list-model';
import {CustomerOverviewList} from '../../dto/customerOverviewList';
import {CollectionCaseContainer} from '../../dto/customer';
import {WebIdTransaction} from '../../dto/web-id-transaction';
import {IdvUploadDto} from '../../dto/idv-upload';

@Injectable({
  providedIn: 'root'
})
export class CollectionService {

  readonly apiPath = 'collection-search/';

  constructor(private http: HttpClient) {

  }

  getCase(
    caseNumber: string,
  ) {
    const params = new HttpParams()
      .set('caseNumber', caseNumber);

    return this.http.get(this.apiPath + 'case', { params, headers: {'skip-error-snack': 'true' }}) as Observable<CollectionCaseContainer>;
  }

  getCasePdf(
    caseNumber: string,
  ) {
    const params = new HttpParams()
      .set('caseNumber', caseNumber);

    return this.http.get(this.apiPath + 'case-pdf-public', { params, headers: {'skip-error-snack': 'true' }, responseType: 'blob', observe: 'response' }) as Observable<HttpResponse<Blob>>;

  }


  getIdents(customerId: number): Observable<WebIdTransaction[]> {
    return this.http.get(this.apiPath + 'get-ident/' + customerId) as Observable<WebIdTransaction[]>;
  }

  getAllDocuments(customerId: number): Observable<any> {
    return this.http.get(this.apiPath + 'get-all-documents/' + customerId) as Observable<IdvUploadDto[]>;
  }

}
